import { render } from "./SearchView.vue?vue&type=template&id=702214d1"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=702214d1&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__